/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAdsUnavailableAccountRuntimeStatus
 */
export interface GoogleAdsUnavailableAccountRuntimeStatus {
    /**
     * 
     * @type {string}
     * @memberof GoogleAdsUnavailableAccountRuntimeStatus
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAdsUnavailableAccountRuntimeStatus
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAdsUnavailableAccountRuntimeStatus
     */
    reason?: string;
}

/**
 * Check if a given object implements the GoogleAdsUnavailableAccountRuntimeStatus interface.
 */
export function instanceOfGoogleAdsUnavailableAccountRuntimeStatus(value: object): value is GoogleAdsUnavailableAccountRuntimeStatus {
    return true;
}

export function GoogleAdsUnavailableAccountRuntimeStatusFromJSON(json: any): GoogleAdsUnavailableAccountRuntimeStatus {
    return GoogleAdsUnavailableAccountRuntimeStatusFromJSONTyped(json, false);
}

export function GoogleAdsUnavailableAccountRuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAdsUnavailableAccountRuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GoogleAdsUnavailableAccountRuntimeStatusToJSON(json: any): GoogleAdsUnavailableAccountRuntimeStatus {
    return GoogleAdsUnavailableAccountRuntimeStatusToJSONTyped(json, false);
}

export function GoogleAdsUnavailableAccountRuntimeStatusToJSONTyped(value?: GoogleAdsUnavailableAccountRuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'reason': value['reason'],
    };
}

